/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import { ButtonContent, AddButton } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import Icon from 'components/Icon';
import { camelCase, uniqueId } from 'lodash';
import * as yup from 'yup';
import {
    FormSection,
    FormContainer,
    ContentCard,
    Button,
    ButtonContainer,
    LostCancelButton,
    HasPermission,
    NotesAccordion,
    NotesModal
} from '@fitinsur/components'
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useGetQuestionnairesByIdProduct } from 'services/QuestionnairesService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetCommercialPlansByIdOperationSync } from 'services/CommercialPlansService';
import { useCalculateSync } from 'services/PremiumCalculationService';
import { groupMultipleFieldQuestions, handleQuestionChange, handleQuestionsInitialAdjustments, handleRequestSerproCnpj, onValidationError, removeAnswersDuplicateSession, sectionIsVisible } from './handleQuestionChange';
import {
    useSaveOperations,
    useGetOperationAsync,
    useUpdateOperationSync,
    useResetOperationState
} from 'services/OperationService';
import {
    useGetQuestionnaireAnswer,
    useSaveQuestionnaireAnswer,
    useDeleteQuestionnaireAnswer
} from 'services/QuestionnaireAnswerService';
import {
    useGetInterpolationLimits,
} from 'services/QuestionnairesService';


export default function EditEnquirity({ permissions, match, ...props }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const [organizationGroup, setOrganizationGroup] = useState([]);
    const [externalEntityGroup, setExternalEntityGroup] = useState([]);
    const [coInsuredGroup, setCoInsuredGroup] = useState([]);
    const [partners, setPartners] = useState([]);
    const [isAwaitingAnalysis, setIsAwaitingAnalysis] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [questionnaire, setQuestionnaire] = useState([]);
    const [operation, setOperation] = useState(null);
    const [idOperation, setIdOperation] = useState(match.params?.idOperation || null);
    const [notesModal, setNotesModal] = useState(false);
    const [product, setProduct] = useState({});
    const [isBound, setIsBound] = useState(false);
    const [hasSubscribeRatingAnswer, setHasSubscribeRatingAnswer] = useState(null);
    const [attachmentsIsVisible, setAttachmentsIsVisible] = useState(false);
    const [periodicityText, setPeriodicityText] = useState('-');
    const [infoRequiredDocs, setInfoRequiredDocs] = useState('');
    const goToNextPage = useRef(false);
    const questionnaireSent = useRef(false);
    const [currentModality, setCurrentModality] = useState(null);
    const [forceLoading, setForceLoading] = useState(null);
    const authContext = useContext(GlobalAuthContext);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const formikRef = useRef();
    const location = useLocation();
    const handleBack = () => history.goBack();
    const isClient = authContext.enumProfile === 1 ? true : false;
    const [isEdit, setIsEdit] = useState(false);

    const SECTIONS = {
        RISKS: { name: 'RISKS', isMultiple: false, isRisk: false },
        OPERATION: { name: 'OPERATION', isMultiple: false, isRisk: false },
        ANALYSIS_INFO: { name: 'ANALYSIS_INFO', isMultiple: false, isRisk: false },
        PERSONS: { name: 'PERSONS', isMultiple: false, isRisk: false },
        COINSURED: { name: 'COINSURED', isMultiple: true, isRisk: false },
        ORGANIZATION: { name: 'ORGANIZATION', isMultiple: true, isRisk: false },
        EXTERNAL: { name: 'EXTERNAL', isMultiple: true, isRisk: false },
        PARTNER: { name: 'PARTNER', isMultiple: true, isRisk: false },
        ATTACHMENTS: { name: 'ATTACHMENTS', isMultiple: false, isRisk: false },
        UNDERWRITER: { name: 'UNDERWRITER', isMultiple: false, isRisk: false },
    };

    const getQuestionUniqueKey = (question, index) => {
        const key = `${camelCase(question.dsQuestion)}${index != null ? `_${index}` : ""}_${uniqueId()}`;
        formikRef.current.setFieldValue(key, question.behaviorObject?.defaultValue || "");
        return key;
    };

    const disableButton = (operation) => {
        if (isClient && operation.idDomain !== 26) return true;
        if (isClient && operation.idDomainStatus && operation.idDomainStatus !== 1 && operation.idDomainStatus !== 8) return true;
        return false
    }

    const queryStringToJSON = () => {
        var pairs = location.search.slice(1).split('&');

        var result = {};
        pairs.forEach(pair => {
            pair = pair.split('=');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        });

        return JSON.parse(JSON.stringify(result));
    }

    const { back } = queryStringToJSON();

    const {
        data: getQuestionnaireData,
        loading: getQuestionnaireLoading,
        error: getQuestionnaireError,
        status: getQuestionnaireStatus,
        request: getQuestionnaireRequest,
    } = useGetQuestionnairesByIdProduct(match.params.idProduct);

    const {
        data: useGetQuestionnairesAnswersData,
        loading: useGetQuestionnairesAnswersLoading,
        error: useGetQuestionnairesAnswersError,
        status: useGetQuestionnairesAnswersStatus,
        request: useGetQuestionnairesAnswersRequest,
    } = useGetQuestionnaireAnswer(match.params.idOperation);

    const {
        data: useGetInterpolationLimitsData,
        loading: useGetInterpolationLimitsLoading,
        error: useGetInterpolationLimitsError,
        status: useGetInterpolationLimitsStatus,
        request: useGetInterpolationLimitsRequest,
    } = useGetInterpolationLimits(match.params.idOperation);

    const {
        data: useSaveOperationsData,
        loading: useSaveOperationsLoading,
        error: useSaveOperationsError,
        status: useSaveOperationsStatus,
        request: useSaveOperationsRequest,
    } = useSaveOperations();

    const {
        data: useSaveQuestionnaireAnswerData,
        loading: useSaveQuestionnaireAnswerLoading,
        error: useSaveQuestionnaireAnswerError,
        status: useSaveQuestionnaireAnswerStatus,
        request: useSaveQuestionnaireAnswerRequest,
    } = useSaveQuestionnaireAnswer(idOperation);

    const {
        loading: useGetOperationLoading,
        request: useGetOperationRequest
    } = useGetOperationAsync(match.params.idOperation);

    const {
        loading: useUpdateOperationLoading,
        request: useUpdateOperationRequest
    } = useUpdateOperationSync(idOperation);

    const {
        data: useVerifyRiskAcceptanceData,
        loading: useVerifyRiskAcceptanceLoading,
        error: useVerifyRiskAcceptanceError,
        status: useVerifyRiskAcceptanceStatus,
        request: useVerifyRiskAcceptanceRequest
    } = useVerifyRiskAcceptance(idOperation);

    const {
        loading: useGetCommercialPlansByIdOperationLoading,
        request: useGetCommercialPlansByIdOperationRequest
    } = useGetCommercialPlansByIdOperationSync(match.params.idOperation);

    const {
        loading: useCalculateLoading,
        request: useCalculateRequest
    } = useCalculateSync(match.params.idOperation);

    const {
        data: useResetOperationStateData,
        loading: useResetOperationStateLoading,
        error: useResetOperationStateError,
        status: useResetOperationStateStatus,
        request: useResetOperationStateRequest,
    } = useResetOperationState(idOperation);

    useEffect(() => {
        if (match.params.idOperation) {
            useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
                let operationData;
                if (response.status === 200) {
                    operationData = response.data?.value;
                    setOperation(operationData);
                    setIsAwaitingAnalysis(operationData?.idDomainStatus === 10);
                    setIsBound([5, 2, 6].includes(operationData?.idDomainStatus))
                }

                if (back) {
                    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: 7 })
                } else {
                    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus })
                }
            });
        } else {
            getQuestionnaireRequest(null, { idDomainStatus: 7 })
        }
    }, []);

    useEffect(() => {
        if (getQuestionnaireStatus === 200 || useGetQuestionnairesAnswersStatus === 200) {
            handleQuestionnaire(getQuestionnaireData?.value || useGetQuestionnairesAnswersData?.value)

            const { isEdit: isHistoryEdit } = history?.location?.state ?? {};
            setIsEdit(isHistoryEdit || [1, 7, 4].includes(operation?.idDomainStatus) || !operation?.idDomainStatus);
        }
    }, [getQuestionnaireStatus, useGetQuestionnairesAnswersStatus]);

    useEffect(() => {
        const { values } = formikRef.current;
        if (!useSaveOperationsStatus) return;

        if (useSaveOperationsStatus === 200) {
            setIdOperation(useSaveOperationsData.value.idOperation)
            if (idOperation) handleSaveQuestionnaireAnswer(values, idOperation);
        }
    }, [useSaveOperationsStatus, idOperation]);

    useEffect(() => {
        if (useSaveQuestionnaireAnswerStatus === 200) {
            useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus })
            useVerifyRiskAcceptanceRequest(null, {
                draft: true
            });
        }

        if (useSaveQuestionnaireAnswerStatus === 400) {
            useSaveQuestionnaireAnswerError.errors?.map(error => {
                if (error.message) mc.error(error.message)
            })
        }
    }, [useSaveQuestionnaireAnswerStatus]);

    useEffect(() => {
        const save = async () => {
            if (useVerifyRiskAcceptanceStatus === 200) {
                if (!goToNextPage.current) {
                    match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);
                    return history.push('/list');
                }
                const { riskDescription, riskQuestions } = useVerifyRiskAcceptanceData?.value;
                if (riskDescription === 'Declinar') {
                    useUpdateOperationRequest({ idDomainStatus: 2 }).then(() => {
                        mc.error('Esta atividade não tem aceitação.');
                        return history.push('/list');
                    });

                    return
                }

                const questionnaireAnswers = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
                const subscribeRatingAnswer = questionnaireAnswers.find(q => q.idQuestion == 1201)?.idAnswerOption;

                if (subscribeRatingAnswer == 6129 && !hasSubscribeRatingAnswer) {
                    const { status } = await useResetOperationStateRequest({ idDomainOrigin: 26 })

                    useUpdateOperationRequest({ idDomainStatus: 10 })
                    mc.success('Esta cotação será enviada para análise do subscritor');
                    if (status === 200) return history.push('/list');
                }

                if (riskDescription === 'Analisar') {
                    setAttachmentsIsVisible(true);
                    if ([1, 4, 8].includes(operation?.idDomainStatus)) {
                        if (operation?.idDomainStatus === 1 && back && goToNextPage.current) {
                            match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);
                            history.replace(`/edit-enquiry/${match.params.idProduct}/${idOperation}`)
                            window.location.reload();
                            return
                        }

                        if (!goToNextPage.current) {
                            match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);
                            return history.push('/list');
                        }

                        let attachments = formikRef.current.values['$ANSWERS_ATTACHMENTS']?.find(qst => qst.idQuestion === 694);
                        if (!attachments || !Array.isArray(attachments.answer)) attachments = [];

                        const filteredQuestions = riskQuestions.filter(qst => qst?.idDomainRisk === 40);
                        const typesRequiredDocuments = [];
                        for (const question of filteredQuestions) {
                            if ([1173, 675, 677, 679, 1197, 681, 674].includes(question.idQuestion) && !typesRequiredDocuments.includes(4632)) {
                                typesRequiredDocuments.push(4632, 4633)
                            } else if (question.idQuestion === 676) {
                                if (!typesRequiredDocuments.includes(4632)) {
                                    typesRequiredDocuments.push(4632, 4633, 6125, 6126)
                                } else {
                                    typesRequiredDocuments.push(6125, 6126)
                                }
                            } else if (question.idQuestion === 680) {
                                typesRequiredDocuments.push(6123)
                            } else if (question.idQuestion === 1174) {
                                typesRequiredDocuments.push(6124)
                            }
                        }

                        let missingDocuments = false;
                        let attachmentQuestion = questionnaire.find((q) => q.idQuestion == 694);
                        let descriptionDocs = '';
                        for (const type of typesRequiredDocuments) {
                            const description = attachmentQuestion.answerOptions.find(opt => opt.idAnswerOption === type).dsAnswerOption;
                            descriptionDocs += `${description + '\n'}`;
                            if (!attachments.answer?.find(doc => +doc.documentType?.idAnswerOption === type)) {
                                if (!missingDocuments) missingDocuments = true;
                                mc.error(`Foi identificado que o ${description} não foi incluído; Favor anexa-lo!`);
                            }
                        }

                        setInfoRequiredDocs(descriptionDocs)

                        if (missingDocuments) return

                        if (operation?.idDomainStatus !== 10) {
                            if ((permissions && !permissions.NBI_REQUEST_APPROVE_REJECT)) {
                                const { status } = await useResetOperationStateRequest({ idDomainOrigin: 26 })
                                useUpdateOperationRequest({ idDomainStatus: 10 })
                                mc.success('Esta cotação será enviada para análise do subscritor');

                                if (status === 200) return history.push('/list');
                            }
                        }
                    }
                }

                if (!back && [10, 1, 8, 4].includes(operation?.idDomainStatus)) {
                    if (operation?.idDomainStatus === 1 && !goToNextPage.current) {
                        match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);
                        if (!back && !goToNextPage.current) return history.push('/list');
                    }

                    useGetCommercialPlansByIdOperationRequest().then(async (response) => {
                        const { status, data } = response;

                        if (status !== 200) return

                        if (!data.value.length) {
                            await useUpdateOperationRequest({ idDomainStatus: 2 })
                            mc.error('Esta atividade não tem aceitação.');
                            return history.push('/list');
                        }

                        const { status: statusCalculate } = await useCalculateRequest(null, { disableOptionalCoverages: +match.params.idProduct === 48 });
                        if (statusCalculate !== 200) return
                        history.push(`/quote/plans/${match.params.idProduct}/${operation.idOperation}`)
                    });
                } else {
                    match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);

                    if (!back && !goToNextPage.current) return history.push('/list');
                    history.replace(`/edit-enquiry/${match.params.idProduct}/${idOperation}`)
                    window.location.reload();
                }
            }
        }

        save();
    }, [useVerifyRiskAcceptanceStatus]);

    useEffect(() => {
        updateIsLoadingStatus(
            getQuestionnaireLoading ||
            useGetQuestionnairesAnswersLoading ||
            useSaveOperationsLoading ||
            useSaveQuestionnaireAnswerLoading ||
            useGetOperationLoading ||
            useUpdateOperationLoading ||
            useVerifyRiskAcceptanceLoading ||
            useGetCommercialPlansByIdOperationLoading ||
            useCalculateLoading ||
            useResetOperationStateLoading ||
            useGetInterpolationLimitsLoading ||
            forceLoading
        )
    }, [
        getQuestionnaireLoading,
        useGetQuestionnairesAnswersLoading,
        useSaveOperationsLoading,
        useSaveQuestionnaireAnswerLoading,
        useGetOperationLoading,
        useUpdateOperationLoading,
        useVerifyRiskAcceptanceLoading,
        useGetCommercialPlansByIdOperationLoading,
        useCalculateLoading,
        useResetOperationStateLoading,
        useGetInterpolationLimitsLoading,
        forceLoading
    ]);

    const handleQuestionnaire = async (data) => {
        let questionnaire = [];
        questionnaire = [
            ...data.persons,
            ...data.operations,
            ...data.payments,
            ...data.risks
        ];
        questionnaire = handleQuestionsInitialAdjustments(questionnaire, setPeriodicityText, operation, back);

        if (!permissions.NBI_REQUEST_APPROVE_REJECT)
            questionnaire = questionnaire.filter(qst => ![1201, 1204, 1205, 1309].includes(qst.idQuestion));

        questionnaire = questionnaire.map((question, index) => {
            if (question.idQuestion === 1213) {
                question.answer = authContext?.login_response?.ret_value?.applicationPersonRoot
            }
            return question;
        });

        const isQuestions = questionnaire.filter(question => question.idQuestion === 682);
        if (!match.params.idOperation || isQuestions.length < 3) {
            //forçar duplicatas da questão
            questionnaire.map((question, index) => {
                if (question.idQuestion === 682) {
                    question.idAnswerOption = null;
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                }
            });
        } else if (isQuestions.length) {
            questionnaire = questionnaire.map((question, index) => {
                if (question.idQuestion === 682) {
                    return { ...question, key: getQuestionUniqueKey(question, index) }
                }
                return question;
            });
        }

        const isQuestionsCoverage = questionnaire.filter(question => question.idQuestion === 1250);
        if (!match.params.idOperation || isQuestionsCoverage.length < 3) {
            //forçar duplicatas da questão
            questionnaire.map((question, index) => {
                if (question.idQuestion === 1250) {
                    question.idAnswerOption = null;
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                }
            });
        } else if (isQuestionsCoverage.length) {
            questionnaire = questionnaire.map((question, index) => {
                if (question.idQuestion === 1250) {
                    return { ...question, key: getQuestionUniqueKey(question, index) }
                }
                return question;
            });
        }

        const typeOfApplicationQuestion = questionnaire.find(question => question.idQuestion === 1236);
        if (typeOfApplicationQuestion) {
            typeOfApplicationQuestion.idAnswerOption = typeOfApplicationQuestion?.idAnswerOption || typeOfApplicationQuestion?.behaviorObject?.defaultValue;

            const answerOption = typeOfApplicationQuestion?.idAnswerOption
                ? typeOfApplicationQuestion.answerOptions.find(answerOption => answerOption.idAnswerOption === typeOfApplicationQuestion.idAnswerOption)
                : typeOfApplicationQuestion.answerOptions.find(answerOption => answerOption.idAnswerOption === typeOfApplicationQuestion.behaviorObject.defaultValue);
            const { resultProductPlan } = answerOption?.behaviorObject || {};

            setCurrentModality(resultProductPlan);
        }
        questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
        setOrganizationGroup(groupMultipleFieldQuestions(661, questionnaire, operation, isBound))
        setExternalEntityGroup(groupMultipleFieldQuestions(663, questionnaire, operation, isBound))
        setCoInsuredGroup(groupMultipleFieldQuestions(1234, questionnaire, operation, isBound))
        setPartners(groupMultipleFieldQuestions(1190, questionnaire, operation, isBound))
        setQuestionnaire(questionnaire);
        if (hasSubscribeRatingAnswer == null) setHasSubscribeRatingAnswer(questionnaire.find(q => q.idQuestion == 1201)?.idAnswerOption === 6129);

        const hasAttachments = !!questionnaire.find(q => q.idQuestion == 694)?.answer
        setAttachmentsIsVisible(hasAttachments || [10, 4].includes(operation?.idDomainStatus));
    }

    const getQuoteQuestionnaire = async () => {
        fitinsur.setAuthToken(authContext.token);
        let response = await fitinsur.requestProductsList().then(v => v.json())
        if (response.ret_code != 200) return;
        let product = response.ret_value.find(v => +v.ID_PRODUCT === +match.params.idProduct);
        setProduct(product);
    }

    const buildValidation = (draft) => {
        const validationSchema = {};

        const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
        for (const question of questionnaire) {
            if (draft && ![658, 660, 688, 1225, 1226].includes(question.idQuestion)) continue;
            if ([614].includes(question.idDomainQuestion)) continue;
            if (!question.key || question.behaviorObject.sectionName === "INSURED") continue;
            validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
                ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                    return !!question.answer;
                }) : yup.string().notRequired();
        }

        return yup.object().shape(validationSchema);
    }


    const onSave = (values, idDomainStatus, draft) => {
        goToNextPage.current = idDomainStatus != null;
        buildValidation(draft).validate(values, { abortEarly: false })
            .then(() => {
                handleSubmit(values, idDomainStatus)
            })
            .catch((e) => {
                onValidationError(e, mc, formikRef, questionnaire, [...partners, ...externalEntityGroup, ...organizationGroup, ...coInsuredGroup])
            })
    }

    const handleSubmit = async (values, idDomainStatus) => {
        if (questionnaireSent.current) return;
        if (!match.params.idOperation) {
            useSaveOperationsRequest({
                idDomain: 26,
                idDomainStatus: idDomainStatus || 7,
                idProduct: match.params.idProduct,
                idPerson: authContext?.login_response?.ret_value?.idPerson
            });
        }

        if (match.params.idOperation) {
            if (operation?.idDomainStatus === 7 && idDomainStatus === 1) {
                await useUpdateOperationRequest({ idDomainStatus })
            }

            handleSaveQuestionnaireAnswer(values, match.params.idOperation);
        }
    }

    const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
        const formValues = JSON.parse(JSON.stringify(values));

        const body = { questionnaireAnswers: [] };
        for (const [key, section] of Object.entries(SECTIONS)) {
            if (section.isMultiple) {
                let multipleFields = []
                switch (section.name) {
                    case 'ORGANIZATION':
                        multipleFields = organizationGroup;
                        break;
                    case 'EXTERNAL':
                        multipleFields = externalEntityGroup;
                        break;
                    case 'COINSURED':
                        multipleFields = coInsuredGroup;
                        break;
                    case 'PARTNER':
                        multipleFields = partners;
                        break;
                    default:
                        multipleFields = [];
                        break;
                }

                multipleFields.map((field, index) => {
                    let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
                    if (sectionAnswers?.length) {
                        const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
                        const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
                        rootQuestion.childrenQuestions = childrenQuestions
                        if (!onlyQuestions) {
                            body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
                        } else {
                            body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
                        }
                    }
                })
            } else {
                let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
                if (sectionAnswers) {
                    body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
                }
            }
        }

        for (const question of body.questionnaireAnswers) {
            if ((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer) {
                try {
                    question.answer = JSON.stringify(question.answer)
                } catch (e) {
                }
            }
        }

        body.questionnaireAnswers = body.questionnaireAnswers.filter(v => ![682, 694, 1250].includes(v.idQuestionRoot));

        if (onlyQuestions) return body.questionnaireAnswers;

        const getInterpolationLimits = async () => {
            setForceLoading(true);
            for (const question of body.questionnaireAnswers) {
                if (![682, 1250].includes(question.idQuestion)) continue;

                const interpolationLimitsUpdated = await handleInterpolationQuestions(
                    question.answer,
                    question,
                    null,
                    body.questionnaireAnswers,
                    null,
                )

                if (interpolationLimitsUpdated) body.questionnaireAnswers = interpolationLimitsUpdated;
                await new Promise(resolve => setTimeout(() => resolve(), 500));
            }
        }

        if (idOperation) {
            var total = 0
            const percentage = body.questionnaireAnswers.filter(question => question.idQuestion === 1190);

            if (!percentage.length) total = 100;
            percentage.map((qst) => {
                if (percentage.length === 1 && !qst.answer) return total = 100;
                const question = qst.childrenQuestions?.find(v => v.idQuestion === 1192)
                if (question) total += parseFloat(question.answer || 0)
            });

            if (total !== 100) {
                mc.error('A composição do capital Social deve totalizar 100%')
            } else {
                 if (!match?.params?.idOperation) questionnaireSent.current = true;
                 getInterpolationLimits().then(() => {
                    const result = body.questionnaireAnswers.filter(({ idQuestion }) => ![1246, 1248].includes(idQuestion));
                    useSaveQuestionnaireAnswerRequest(result);
                 })
             }
        }
    }

    const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, values) => {
        return (
            <>
                {index !== 0 ?
                    <AddButton style={{ marginBottom: '15px' }} onClick={(e) => {
                        e.preventDefault(); e.stopPropagation();
                        setFunction(array.filter((v, i) => i !== index));
                    }}>
                        <Icon name="trash" style={{ margin: 0 }} />
                    </AddButton> : <></>}
                {index === array.length - 1 ?
                    <AddButton onClick={(e) => {
                        e.preventDefault(); e.stopPropagation();
                        setFunction([...array, removeAnswersDuplicateSession(questions)]);
                    }}>
                        <Icon name="plus" style={{ margin: 0 }} />
                    </AddButton> : <></>}
            </>
        )
    }

    const handleInterpolationQuestions = async (value, question, setFieldValue, filteredQuestionnaire, setFilteredQuestionnaire) => {
        if (![682, 1250].includes(question.idQuestion)) return;

        if (String(value).includes(",")) {
            value = Number(String(value).replace('R$', '').replace(/\./g, '').replace(/,/g, '.').trim());
        }

        if (!operation?.idOperation) return;

        let idDomainDocument = null;
        const companyActivityQst = filteredQuestionnaire.find(qst => qst.idQuestion === 1236);

        if (!companyActivityQst && +match.params.idProduct === 48) return;

        if (companyActivityQst) {
            const { resultIdDomainDocument } = companyActivityQst.answerOptions.find(
                opt => opt.idAnswerOption === companyActivityQst?.idAnswerOption
            )?.behaviorObject || {};

            if (!resultIdDomainDocument) return;
            idDomainDocument = resultIdDomainDocument;
        }

        if (value) {
            if (value < question.behaviorObject.fieldMinValue) {
                value = question.behaviorObject.fieldMinValue;
                question.answer = String(value);
            } else if (value > question.behaviorObject.fieldMaxValue) {
                value = question.behaviorObject.fieldMaxValue;
                question.answer = String(value);
            }
        }

        setForceLoading(true);

        const interpolationParams = [];
        if (+match.params.idProduct === 34) {
            interpolationParams.push({
                idQuestions: [675, 1173],
                idDomainDocument: 647,
                limit: value,
                optionalParams: [
                    {
                        name: 'mapQuestion675',
                        value: filteredQuestionnaire.find(qst => qst.idQuestion === 675)?.idAnswerOption || ''
                    },
                    {
                        name: 'mapQuestion1173',
                        value: filteredQuestionnaire.find(qst => qst.idQuestion === 1173)?.idAnswerOption || ''
                    }
                ]
            });
        } else if (+match.params.idProduct === 48) {
            if (idDomainDocument) {
                const params = {
                    idQuestions: [1237],
                    idDomainDocument: idDomainDocument,
                    limit: value,
                };

                interpolationParams.push(
                    {
                        ...params,
                        optionalParams: [
                            {
                                name: 'deductibleType',
                                value: 'FN'
                            },
                            {
                                name: 'mapQuestion1237',
                                value: filteredQuestionnaire.find(qst => qst.idQuestion === 1237)?.idAnswerOption || ''
                            }
                        ]
                    },
                    {
                        ...params,
                        optionalParams: [
                            {
                                name: 'deductibleType',
                                value: 'FA'
                            },
                            {
                                name: 'mapQuestion1237',
                                value: filteredQuestionnaire.find(qst => qst.idQuestion === 1237)?.idAnswerOption || ''
                            }
                        ]
                    }
                );
            }
        }

        for (const params of interpolationParams) {
            const response = await useGetInterpolationLimitsRequest(null, params);

            if (response.status !== 200) {
                setTimeout(() => setForceLoading(false), 2000);
                return;
            }

            const { interpolationLimits, coverages } = response.data.value;

            if (question && value) {
                question.childrenQuestions = JSON.parse(JSON.stringify(question.childrenQuestions));
                const deductibleType = params?.optionalParams?.find(param => param.name === 'deductibleType');
                question.childrenQuestions = question.childrenQuestions.map(q => {
                    if (!deductibleType) {
                        if (q.idQuestion === 1312) {
                            q.answerJson = null;
                            q.answer = JSON.stringify(coverages);
                        }
                        if (q.idQuestion === 1313) {
                            q.answerJson = null;
                            q.answer = JSON.stringify(interpolationLimits);
                        }
                    } else {
                        const idQuestion = deductibleType?.value === 'FN' ? 1388 : 1390;
                        if (q.idQuestion === idQuestion) {
                            q.answer = JSON.stringify(coverages);
                        } else if (q.idQuestion === 1387 && interpolationLimits?.length) {
                            q.answer = JSON.stringify(interpolationLimits);
                        }
                    }
                    return q;
                });

                filteredQuestionnaire = filteredQuestionnaire.map(q => {
                    if (q.key === question.key) q = question;
                    return q;
                });
            }
        }

        setTimeout(() => setForceLoading(false), 2000);

        if (question && value) {
            setFilteredQuestionnaire && setFilteredQuestionnaire(filteredQuestionnaire);
            return filteredQuestionnaire
        }
    }

    useEffect(() => {
        getQuoteQuestionnaire();
    }, []);

    useEffect(() => {
        buildValidation();
    }, [questionnaire, partners, externalEntityGroup, organizationGroup, coInsuredGroup]);

    useEffect(() => {
        setHasPermission((operation?.idOperation && !permissions.EDIT_ENQUIRY_SAVE) || (!operation?.idOperation && !permissions.CREATE_ENQUIRY));
    }, [permissions]);

    return (
        <Layout
            title={operation?.idOperation ? "Editar Cotação" : "Nova Cotação"}
            subtitle={`${product?.PRODUCT_NAME || ""}`}
            extraSubtitle={`${operation?.idOperation || ""}`}
        >
            <StepNavigation
                stage={1}
                idOperation={match?.params?.idOperation}
                permissions={permissions}
            />

            {operation?.idOperation && (
                <div>
                    <NotesAccordion
                        history={history}
                        title="Anotações"
                        idOperation={operation?.idOperation}
                        idQuestion={789}
                    />
                </div>
            )}

            <NotesModal
                title={'Informações Adicionais'}
                textButtonConfirm={'Confirmar'}
                textButtonCancel={'Cancelar'}
                show={notesModal}
                setModalShow={setNotesModal}
                idOperation={idOperation}
                idQuestion={1198}
                functionCallback={async () => {
                    await useResetOperationStateRequest({ idDomainOrigin: 26 });
                    const { status } = await useUpdateOperationRequest({ idDomainStatus: 4 });
                    if (status === 200) history.push('/enquiries');
                }}
            />

            <ContentCard title=" ">
                <Formik
                    innerRef={formikRef}
                    initialValues={{}}
                    validateOnChange={false}
                    validateOnBlur={false}
                    enableReinitialize={true}
                >
                    {({ values, setFieldValue, errors, setFieldError }) => (
                        <Form>
                            {sectionIsVisible("PERSONS", questionnaire) && <FormContainer
                                title="Dados do Proponente / Tomador"
                            >
                                <FormSection
                                    sectionName="PERSONS"
                                    disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                    showWarning={isAwaitingAnalysis || !isEdit}
                                    idProduct={match.params.idProduct}
                                    values={values}
                                    errors={errors}
                                    setFieldValue={setFieldValue}
                                    setFieldError={setFieldError}
                                    questionnaire={questionnaire}
                                    ignoreModality
                                    onRequestSerproCnpj={(
                                        question,
                                        data,
                                        filteredQuestionnaire,
                                        setFilteredQuestionnaire,
                                        setFieldValue
                                    ) => handleRequestSerproCnpj(question,
                                        data,
                                        filteredQuestionnaire,
                                        setFilteredQuestionnaire,
                                        setFieldValue
                                    )}
                                    onQuestionChange={(
                                        question,
                                        value,
                                        filteredQuestionnaire,
                                        setFilteredQuestionnaire,
                                        setFieldValue
                                    ) => handleQuestionChange(
                                        question,
                                        value,
                                        filteredQuestionnaire,
                                        setFilteredQuestionnaire,
                                        setFieldValue,
                                        questionnaire,
                                    )}
                                    permissions={permissions}
                                />

                                {coInsuredGroup.map((questions, index) => (
                                    <FormSection
                                        sectionName="COINSURED"
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        sectionIndex={index}
                                        questionnaire={questions}
                                        formikRef={formikRef}
                                        extraButtons={() => renderAddAndRemoveButtons(
                                            coInsuredGroup,
                                            index,
                                            questions,
                                            setCoInsuredGroup,
                                            "$ANSWERS_COINSURED_0",
                                            values
                                        )}
                                        idOperation={match?.params?.idOperation}
                                        idOperationParent={match?.params?.idOperationParent}
                                        ignoreModality
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        )}
                                    />
                                ))}

                                {partners.map((questions, index) => (
                                    <FormSection
                                        sectionName="PARTNER"
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        sectionIndex={index}
                                        questionnaire={questions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        extraButtons={() => renderAddAndRemoveButtons(
                                            partners,
                                            index,
                                            questions,
                                            setPartners,
                                            "$ANSWERS_PARTNER_0",
                                            values
                                        )}
                                        idOperation={match?.params?.idOperation}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreModality
                                        onQuestionChange={(
                                            question,
                                            value,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue,
                                            questionnaire,
                                        )}
                                        permissions={permissions}
                                    />
                                ))}

                                {organizationGroup.map((questions, index) => (
                                    <FormSection
                                        sectionName="ORGANIZATION"
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        sectionIndex={index}
                                        questionnaire={questions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        extraButtons={() => renderAddAndRemoveButtons(
                                            organizationGroup,
                                            index,
                                            questions,
                                            setOrganizationGroup,
                                            "$ANSWERS_ORGANIZATION_0",
                                            values
                                        )}
                                        idOperation={match?.params?.idOperation}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreModality
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        )}
                                        permissions={permissions}
                                    />
                                ))}

                                {externalEntityGroup.map((questions, index) => (
                                    <FormSection
                                        sectionName="EXTERNAL"
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        sectionIndex={index}
                                        questionnaire={questions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        extraButtons={() => renderAddAndRemoveButtons(
                                            externalEntityGroup,
                                            index,
                                            questions,
                                            setExternalEntityGroup,
                                            "$ANSWERS_EXTERNAL_0",
                                            values
                                        )}
                                        idOperation={match?.params?.idOperation}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreModality
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        )}
                                        permissions={permissions}
                                    />
                                ))}
                            </FormContainer>}

                            {sectionIsVisible("RISKS", questionnaire) &&
                                <FormContainer
                                    title="Questionário de Risco"
                                >
                                    <FormSection
                                        sectionName="RISKS"
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreModality={operation?.idProduct === 34 ? true : false}
                                        currentModality={operation?.idProduct === 48 ? currentModality : null}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            filteredQuestionnaire,
                                            setFilteredQuestionnaire,
                                            setFieldValue,
                                            questionnaire,
                                            setPeriodicityText,
                                            setCurrentModality,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>
                            }

                            <HasPermission permission={permissions.NBI_REQUEST_APPROVE_REJECT}>
                                {sectionIsVisible("ANALYSIS_INFO", questionnaire) &&
                                    <FormSection
                                        sectionName="ANALYSIS_INFO"
                                        disableAll={isBound || hasPermission}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreTypeOfApplication
                                        permissions={permissions}
                                    />
                                }
                            </HasPermission>

                            <HasPermission permission={operation?.idDomainStatus === 4}>
                                {sectionIsVisible("ADDITIONAL_INFORMATION", questionnaire) &&
                                    <FormSection
                                        sectionName="ADDITIONAL_INFORMATION"
                                        disableAll={true}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        ignoreTypeOfApplication
                                        permissions={permissions}
                                    />
                                }
                            </HasPermission>

                            {sectionIsVisible("ATTACHMENTS", questionnaire) && attachmentsIsVisible &&
                                <FormContainer
                                    title="Documentos obrigatórios"
                                    infoContent={infoRequiredDocs}
                                >
                                    <FormSection
                                        disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        sectionName={'ATTACHMENTS'}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreTypeOfApplication
                                        periodicityOptions={[4632, 4633]}
                                        periodicityText={periodicityText}
                                        permissions={permissions}
                                    />
                                </FormContainer>
                            }

                            <ButtonContainer>
                                <Button forth onClick={() => handleBack()}> &lt; VOLTAR PARA LISTA</Button>
                                <HasPermission permission={!isBound}>
                                    <ButtonContent>
                                        {(operation?.idOperation && permissions.NBI_REQUEST_APPROVE_REJECT) && <LostCancelButton idQuestion={697} idOperation={match?.params?.idOperation} />}

                                        <HasPermission permission={[7, 1].includes(operation?.idDomainStatus)}>
                                            <Button
                                                id="btnSave"
                                                type="button"
                                                // @ts-ignore
                                                onClick={async () => {
                                                    history.replace(`${match.params.idOperation}?back=true`);
                                                    window.location.reload()
                                                }}
                                                disabled={disableButton(operation)}
                                                third
                                            >
                                                VOLTAR
                                            </Button>
                                        </HasPermission>

                                        <HasPermission
                                            permission={
                                                operation?.idOperation &&
                                                [10, 8].includes(operation?.idDomainStatus) &&
                                                permissions.NBI_REQUEST_APPROVE_REJECT
                                            }
                                        >
                                            <Button
                                                type="button"
                                                onClick={() => setNotesModal(true)}
                                                third
                                            >
                                                MAIS INFO
                                            </Button>
                                        </HasPermission>

                                        <HasPermission permission={
                                            ((operation?.idOperation && permissions.EDIT_ENQUIRY_SAVE) || (!operation?.idOperation && permissions.CREATE_ENQUIRY)) &&
                                            (!operation?.idOperation ||
                                                ([10].includes(operation?.idDomainStatus) && permissions.NBI_REQUEST_APPROVE_REJECT) ||
                                                ![10].includes(operation?.idDomainStatus)
                                            )
                                        }>
                                            {
                                                (operation?.idDomainStatus == 1 || operation?.idDomainStatus == 7 || !operation?.idDomainStatus) ?
                                                    <Button
                                                        id="btnSave"
                                                        type="button"
                                                        onClick={() => onSave(values, null, true)}
                                                        disabled={disableButton(operation)}
                                                        primary
                                                    >
                                                        SALVAR
                                                    </Button>
                                                    : null
                                            }
                                        </HasPermission>

                                        <HasPermission permission={
                                            !operation?.idOperation ||
                                            ([10].includes(operation?.idDomainStatus) && permissions.NBI_REQUEST_APPROVE_REJECT) ||
                                            ![10].includes(operation?.idDomainStatus)
                                        }>
                                            <Button
                                                id="btnSave"
                                                type="button"
                                                onClick={() => onSave(values, 1, false)}
                                                disabled={disableButton(operation)}
                                                secundary
                                            >
                                                CONTINUAR
                                            </Button>
                                        </HasPermission>
                                    </ButtonContent>
                                </HasPermission>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </ContentCard>
        </Layout >
    )
}